<template>
  <!-- 打分汇总 组长-->
  <div class="position-ab">
    <template v-if="show">
      <!-- 未汇总 -->
      <template v-if="summaryStaus == 0 && !showStart">
        <summaryingOrComplete
          @start="start"
          :scroType="true"
          :type="1"
        ></summaryingOrComplete>
      </template>
      <!-- 汇总中 -->
      <template v-else-if="summaryStaus == 1 || showStart">
        <summaryingComplete
          @start="start"
          :showStart="showStart"
          :status="0"
          :type="1"
        ></summaryingComplete>
      </template>
      <!-- 汇总完成 -->
      <template v-else-if="summaryStaus == 2">
        <summaryingComplete
          :isZy="false"
          :status="1"
          :type="2"
        ></summaryingComplete>
      </template>
    </template>
  </div>
</template>

<script>
import summaryingComplete from "@/app/subSourcingFlow/views/expertEvaluate/components/summaryingComplete.vue";
import summaryingOrComplete from "@/app/subSourcingFlow/views/expertEvaluate/components/summaryingOrComplete.vue";
import { scpQryBidEvaProcessStatusApi } from "@/app/sourcingFlow/api/scp-expertEvaluation.js";

export default {
  name: "scpSkillsScores",
  components: {
    summaryingComplete,
    summaryingOrComplete
  },
  data() {
    return {
      summaryStaus: Number(
        JSON.parse(sessionStorage.getItem("bidEvaProcessStatus")).billStatus
      ), // 0:未汇总 1：汇总中 2：汇总完成
      // type: 1 // 商务技术评分汇总
      // scroType 是否打分汇总
      show: false,
      showStart: false
    };
  },
  mounted() {
    this.getState();
  },
  methods: {
    getState() {
      scpQryBidEvaProcessStatusApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        purStep: this.$router.history.current.query.menuKey
      }).then(res => {
        this.$set(this, "summaryStaus", res.data.data.billStatus);
        this.show = true;
      });
    },

    start(type) {
      console.log(type, "type.....");
      if (type === 1) {
        // 点击开始汇总
        this.showStart = true;
      } else if (type === 2) {
        // 取消汇总
        this.showStart = false;
      } else if (type === 3) {
        // 汇总成功
        this.getState();
        this.showStart = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
